export const getWidth = (): string => {
  if (document.documentElement && document.documentElement.clientHeight) {
    return String(document.documentElement.clientWidth);
  }

  if (document.body) {
    return String(document.body.clientWidth);
  }

  return '0';
};
